<template>
  <div v-for="value in values" :key="value" class="d-block">
    <enum-field
      v-if="value"
      :classes="classes"
      :colors="colors"
      :column="column"
      :resource-type="resourceType"
      :value="value"
    ></enum-field>
    <span v-if="!value" class="text-muted">(leer)</span>
  </div>
</template>

<script>
import EnumField from '@kanrisha/components/Elements/Display/Enum';

export default {
  components: {
    EnumField,
  },
  props: {
    values: { type: Array, default: () => [] },
    column: { type: String, default: '' },
    classes: {
      type: Object,
      default: () => {},
    },
    colors: {
      type: Object,
      default: () => {},
    },
    resourceType: { type: String, default: '' },
  },
  setup() {
    return {};
  },
};
</script>
